import React from "react"
import { useWindowSize } from '../../../hooks/useWindowSize'
import styled from 'styled-components'
import { animated as a } from 'react-spring'

import AnimatedLine from './AnimatedLine'

// import line1 from '../../../images/line1.svg'
// import line2 from '../../../images/line2.svg'
// import line3 from '../../../images/line3.svg'
import line4 from '../../../images/line4.svg'
import line5 from '../../../images/line5.svg'
import line6 from '../../../images/line6.svg'
import line7 from '../../../images/line7.svg'

const Frame = styled(a.div)`
  position: Fixed;
  // right: 0;
  svg {
    position: absolute;
    top: 0;
    left: 0;
    // right: 0;
    min-width: 720px;
    width: 100vw;
    height: auto;
    // height: 100vh;
    // height: ${props => props.height}px;
    fill:#23456e;
    opacity: 0.6;
  }
`

const svgs = [
  // {
  //   id: 1,
  //   src: line1,
  //   width: 719,
  //   height: 1231,
  //   d: `M0,0.9l245.9,116.9c0,0,139.3,78.1,188.3,98.8c51.3,21.7,122,40,201.1,95.8c39.3,27.7,73.9,81.7,80.9,129.2
  //       c12.3,82.8-13.8,143.6-42.4,217.4c-22.5,58.2-89.1,132.4-131.5,178.3c-25.2,27.3-109.1,100.5-109.1,100.5s-257.9,207.8-336.8,255.8
  //       C48.4,1222.8,0,1231.2,0,1231.2`,
  // },
  // {
  //   id: 2,
  //   src: line2,
  //   width: 577,
  //   height: 1076,
  //   d: `M1.2,3L31.3,1l41,2.6c0,0,44.7,9.5,59.1,14.5c18.4,6.4,53.9,22.6,70.7,32.5c17.1,10.1,49.7,32.7,65.3,44.9
  //       c13.7,10.7,40.6,32.9,53.2,44.9c10.6,10.1,40.5,42.4,40.5,42.4s38.4,47.5,50,64.2c9.5,13.6,34.9,56.5,34.9,56.5s25.6,46,33,61.9
  //       c11,23.6,30.8,71.8,39.2,96.5c8.6,25.2,23.1,68.4,30.7,101.9c7.7,33.8,19.5,102.2,23.2,136.6c1.9,16.9,4.7,67.9,4.7,67.9l-2.3,75.8
  //       L564,931l-16.2,70.5l-27.4,74.6`,
  // },
  // {
  //   id: 3,
  //   src: line3,
  //   width: 1632,
  //   height: 1070,
  //   d: `M176.1,1c0,0-62.4,7.2-97.1,37.6S18.5,84.1,3.6,152.2s43.8,146.7,43.8,146.7s89.9,127.9,287,179
  //       s508.9,65.8,763.3,99.6s262.8,24.1,379.5,77.5c116.7,53.5,155.2,169,155.1,204.5s7.8,175.5-180.3,208.8`,
  // },
  {
    id: 0,
    src: line7,
    width: 1440,
    height: 2673,
    d: `M1290.1,2679.7c0,0-24.2-204-131.1-358.9s-195.9-232.4-333.1-222.3l-94.3,21.3c0,0-91.3,17.1-188.9-41
        s-204.4-179.8-268.9-468.8s-105-453.6-157.8-564.5C63,934.6,11,845.3-10.2,817.3`
  },
  {
    id: 3,
    src: line4,
    width: 1440,
    height: 2673,
    d: `M453.2-0.2c0,0-163.2,72.8-230.9,222.2c-80.5,177.7,36.5,322.4,155,369.7c118.5,47.3,195.6,64.1,537.4,4
        c253.4-44.5,538.5,156.9,538.5,156.9`
  },
  {
    id: 4,
    src: line5,
    width: 1440,
    height: 2673,
    d: `M-3.4,365.8c0,0,54.4-36.4,121.8-38s153.3,19.3,251.4,87S570.5,602,626.5,705.2
        c56.1,103.2,93.5,177.1,174.2,290.5c63.8,89.5,235.9,282.4,346,357c103.6,70.2,131.5,102.8,302.9,146.1`
  },
  {
    id: 5,
    src: line6,
    width: 1440,
    height: 2673,
    d: `M1447.6,1221c0,0-92.1,28.2-203.2,95.2s-288.6,186.8-288.6,186.8s-206.5,134.2-334.5,198.6
        s-185.5,93-285.8,131.7s-163.5,54-254,158.2s-86.6,122.8-86.6,122.8`
  },
]

const AnimatedLines = () => {

  // const ref = useRef()
  // const offsetRef = useRef(0)

  // const handleScroll = () => {
  //   const posY = ref.current.getBoundingClientRect().top
  //   const offset = window.pageYOffset - posY;
  //   // offsetRef.current.style.transform = `translateY(${-offset * 0.01}px)`
  // }

  // useEffect(() => {
  //   window.addEventListener('scroll', handleScroll);
  //   return () => {
  //     window.removeEventListener('scroll', handleScroll);
  //   };
  // });

  return (
    <>
      {/* {svgs.map(svg => {
        return <AnimatedLine key={svg.id} svg={svg} delay={svg.id*300} />
      })} */}
      <div>
        {svgs.map(svg => {
          return <AnimatedLine key={svg.id} svg={svg} delay={svg.id*300} />
        })}
      </div>
    </>
  )
}

const Background = () => {

  const size = useWindowSize()

  return (
    <Frame height={size.height}>
      <AnimatedLines />
    </Frame>
  )
}

export default Background